import type { IndustryOptionsObject } from "../../translation-keys/industry-option-keys.js";

const FormIndustryOptions: IndustryOptionsObject = {
  "Active Pharmaceutical Ingredients": "Arzneimittelwirkstoff",
  "Aerospace": "Luft- und Raumfahrt",
  "Animal Health": "Tiergesundheit",
  "Automotive": "Automobilbranche",
  "Banking/Finance/Insurance": "Bankwesen/Finanzen/Versicherungswesen",
  "Biotechnology - Med Device": "Biotechnologie — med. Gerät",
  "Biotechnology - Pharma": "Biotechnologie — Pharmazeutik",
  "Blood & Biologics": "Blut und biologische Präparate",
  "Chemicals": "Chemie",
  "Clinical Research": "Klinische Forschung",
  "Combination Device": "Kombinationsgerät",
  "Combination Pharma": "Kombinations-Pharmazeutik",
  "Communications": "Kommunikation",
  "Computer Equipment/Peripherals": "Computerausstattung/Peripheriegeräte",
  "Construction/Architecture/Engineering": "Bauwesen/Architektur/Ingenieurwesen",
  "Consulting Services": "Beratungsleistungen",
  "Contract Manufacturing - Med Device": "Auftragsfertigung — med. Gerät",
  "Contract Manufacturing - Pharma": "Auftragsfertigung — Pharmazeutik",
  "Contract Research Organization (CRO)": "Auftragsforschungsinstitut (CRO)",
  "Cosmetics": "Kosmetik",
  "Diagnostics - Medical": "Diagnostik — medizinisch",
  "Dietary Supplements": "Nahrungsergänzungsmittel",
  "Distribution": "Vertrieb",
  "Education": "Schulung",
  "Electronics": "Elektronik",
  "Energy": "Energie",
  "Environmental": "Umweltschutz",
  "Food": "Nahrungsmittel",
  "General Manufacturing": "Allgemeine Fertigungsbetriebe",
  "Government": "Behörden",
  "Healthcare": "Gesundheitswesen",
  "Hospital": "Krankenhaus",
  "Laboratory - Biologics": "Labor — biologische Präparate",
  "Laboratory - ISO": "Labor — ISO",
  "Laboratory - MD": "Labor — MG",
  "Laboratory - Other": "Labor — Sonstiges",
  "Lawyer / Law Firm": "Anwalt / Anwaltskanzlei",
  "Life Science Supplier": "Biowissenschaften-Zulieferer",
  "Media": "Medien",
  "Medical Device": "Medizinisches Gerät",
  "Medical Marijuana": "Medizinisches Cannabis",
  "Nuclear": "Nuklear",
  "Oil & Gas / Mining": " Erdöl und Erdgas/Bergbau",
  "Packaging": "Verpackungen",
  "Pharmaceutical": "Pharma",
  "Publishing": "Verlagswesen",
  "Retail": "Einzelhandel",
  "Software/Hardware Supplier": "Software-/Hardwarelieferant",
  "Student/University": "Universität",
  "Technology": "Technologie",
  "Transportation/Logistics": "Transportwesen/Logistik",
  "Travel/Hospitality/Restaurant": "Reise/Gastgewerbe/Restaurant"
};

export default FormIndustryOptions;
